import { default as cx } from "classnames"
import BaseHero from "components/BaseHero"
import BackwardsNav from "components/BaseHero/BackwardsNav"
import { parseColors } from "components/Section"
import Link from "next/link"
import nl2br from "utils/nl2br"
import { getColors } from "../../utils/color-combinations"
import styles from "./ReferenceHero.module.scss"

const ReferenceHero = ({ data }) => {
  const colors = getColors(data)
  const { isLightBackground, accent, background } = parseColors({ colors })

  const {
    title,
    portfolio_images: referenceImages,
    hero_headline: headline,
    hero_description: description,
    kunde: customer = [],
    jahr: year = [],
    sektor: sector = [],
    herausforderung: challenge = [],
    technologien: technologies = [],
    unsere_rolle: roles = [],
    about_the_customer,
    locale,
  } = data

  const image = referenceImages.length > 0 ? referenceImages[0] : null

  return (
    <section className={styles.section}>
      <div
        className={cx(styles.referenceHero, {
          [styles[`referenceHero--${locale}`]]: locale,
        })}
      >
        <BackwardsNav
          locale={locale}
          isLightBackground={isLightBackground}
          url="/referenzen"
          text="Referenzen"
        />
        <BaseHero
          headline={headline || title}
          kicker={headline ? title : null}
          subline={description}
          image={image}
          colors={colors}
          letter={{ value: "none" }}
          locale={locale}
          isArticle={true}
          isReference={true}
          cornersRounded={[0, 0, 1, 0]}
          isFull={true}
          showSubtexts={false}
        />
        <div
          className={styles.factsWrapper}
          style={{ backgroundColor: accent.color, color: background.color }}
        >
          <div className="container">
            <div className={styles.facts}>
              <FactList label="Kunde" items={customer} />
              <FactList label="Jahr" items={year} />
              <FactList label="Branche" items={sector} />
              <FactList label="Leistungsumfang" items={challenge} />
              <FactList label="Technologien" items={technologies} />
              <FactList label="Unsere Rolle" items={roles} />
              <FactList
                label="Über den Kunden"
                text={nl2br(about_the_customer)}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

const FactList = ({ label, items = [], text }) => {
  if (!text && !items.length) return null

  return (
    <div className={styles.factList}>
      {label && <div className={styles.factsHeadline}>{label}</div>}
      {items.length ? (
        <ul>
          {items.map((item, i) => (
            <li key={i}>
              {typeof item.link === "string" ? (
                <Link href={item.link}>
                  <a className="relative z-10">{item.label}</a>
                </Link>
              ) : (
                item.label || item
              )}
            </li>
          ))}
        </ul>
      ) : (
        <p dangerouslySetInnerHTML={{ __html: text }}></p>
      )}
    </div>
  )
}

export default ReferenceHero
